/* 
Rule mixins.

For flexibility and easier unit testing, anything complex is done by the rule helper and the
mixin just call the corresponding rule helper function.
*/
import * as helper from "@/helpers/rule.helper";

export default {
  data() {
    return {
      dateFormatsAccepted: ["YYYY-MM-DD", "DD MMM YYYY", "DD/MM/YYYY", "D/M/YY"],
      dateFormatForDisplay: "DD MMM YYYY",
      dateFormatForPicker: "YYYY-MM-DD",
      timeFormatsAccepted: ["YYYY-MM-DDTHH:mm:ss", "HH:mm", "h:mm A", "HH:mm:ss"],
      timeFormatForDisplay: "h:mm A",
      timeFormatForPicker: "HH:mm:ss",
      dateMinValue: String,
      dateMaxValue: String,
      rules: {
        empty: () => {
          return true;
        },
        required: v => helper.required(v),
        email: v => helper.email(v),
        emails: v => helper.emails(v),
        validDate: v =>
          helper.validDate(v, this.dateFormatsAccepted, this.dateFormatForPicker, this.dateMinValue, this.dateMaxValue),
        validTime: v => helper.validTime(v, this.timeFormatsAccepted),
        greaterThanZero: v => helper.greaterThanZero(v),
        greaterThanZeroPercentage: v => helper.greaterThanZeroPercentage(v),
        zeroOrGreater: v => helper.zeroOrGreater(v),
        betweenZeroAndOne: v => helper.betweenZeroAndOne(v),
        percentage: v => helper.percentage(v),
        integer: v => helper.integer(v),
        number: v => helper.number(v)
      }
    };
  }
};
